module.exports = "{1} ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-utils-notify/services/notify/toast-templates/none.html
// module id = 443
// module chunks = 0